import React, {useEffect, useState} from "react";
import classes from "./profile.module.css";
import Logout from "../Auth/Logout";
import {Link} from "react-router-dom";

const UserIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
    </svg>
);

const UserAuth = ({is_user_auth, onLogin, onLogout, avatar, username}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    // не авторизован → сразу открываем форму входа; авторизован → меню профиля
    const handleClick = () => {
        if (is_user_auth) {
            setMenuOpen((prev) => !prev);
        } else {
            onLogin();
        }
    };

    useEffect(() => {
        if (!menuOpen) return;
        const onKey = (e) => {
            if (e.key === "Escape") setMenuOpen(false);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [menuOpen]);

    return (
        <div className="position-relative d-inline-block">
            {/* Аватар авторизованного / иконка гостя */}
            {is_user_auth && avatar ? (
                <img
                    src={avatar}
                    alt="user"
                    className={classes.logo}
                    onClick={handleClick}
                    style={{cursor: "pointer"}}
                />
            ) : (
                <button
                    type="button"
                    className={classes.avatarBtn}
                    onClick={handleClick}
                    aria-label="Войти"
                >
                    <UserIcon/>
                </button>
            )}

            {/* Меню профиля (только для авторизованного) */}
            {menuOpen && is_user_auth && (
                <div className={classes.menu} style={{width: "220px", zIndex: 1000}}>
                    <button
                        type="button"
                        onClick={() => setMenuOpen(false)}
                        aria-label="Закрыть"
                        style={{
                            position: "absolute",
                            top: "8px",
                            right: "10px",
                            background: "none",
                            border: "none",
                            color: "var(--text-muted)",
                            fontSize: "16px",
                            lineHeight: 1,
                            cursor: "pointer"
                        }}
                    >
                        ✕
                    </button>
                    <div className="text-center mb-2">
                        <img
                            src={avatar}
                            alt="user"
                            className="rounded-circle mb-2"
                            style={{
                                width: "60px",
                                height: "60px",
                                objectFit: "cover",
                                display: "block",
                                margin: "0 auto 8px",
                                borderRadius: "50%"
                            }}
                        />
                        <div className="fw-semibold">Привет, {username} 👋</div>
                    </div>

                    <hr className="my-2"/>

                    <ul className="nav flex-column text-center">
                        <li className="nav-item">
                            <Link to="/profile" onClick={() => setMenuOpen(false)}
                                  className="nav-link py-1" style={{color: "var(--accent)"}}>Профиль</Link>
                        </li>
                    </ul>

                    <hr className="my-2"/>

                    <Logout onLogout={() => {
                        onLogout();
                        setMenuOpen(false);
                    }}/>
                </div>
            )}
        </div>
    );
};

export default UserAuth;
